export default __webpack_public_path__ + "images/XE.11d133b.png";